import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
// import Particle from "../Particle";
import pal from "../../Assets/Projects/pal.png";
import trivago from "../../Assets/Projects/trivago.png";
import p from "../../Assets/Projects/p.png"

function Projects() {
  return (
    <Container fluid className="project-section">
      {/* <Particle /> */}
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={p}
              isBlog={false}
              title="Pharmeasy"
              description="PharmEasy is an Indian online healthcare and medicine delivery platform that connects users with local pharmacies and diagnostic centers. We created the landing page, Product page , sign in and checkout pages. 
              Tech stack: HTML | CSS | JavaScript"
              ghLink="https://github.com/VaishnaviR99/PharmEasy_clone13"
              demoLink="https://pharmaeasy-t13-c38f52.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={trivago}
              isBlog={false}
              title="Trivago"
              description="Trivago is a hotel search with an extensive price comparison. The prices shown come from numerous hotels and booking websites. This means that while users decide on trivago which hotel best suits their needs, the booking process itself is completed through the booking sites.
              Tech stack: HTML | CSS | JavaScript"
              ghLink="https://github.com/ArjoshwaDmello/trivago-Clone-Project"
              demoLink="https://trivago-clone0.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pal}
              isBlog={false}
              title="My FitnessPal"
              description="Myfitnesspal is a health and fitness management website where users get customized diet and calorie requirements based on their lifestyle and fitness goals. The users can keep a track of their everyday meals and workouts and monitor their health effectively.Tech Stack: React | Redux | HTML | CSS | JavaScript"
              ghLink="https://github.com/dilasathapa/myfitnesspal-clone"
              demoLink="https://cw-06-myfitnesspal.netlify.app/"              
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
